import { useState, useEffect } from 'react'

export const useWellnessGoals = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [wellnessGoalsOptions, setWellnessGoalsOptions] = useState([])

  useEffect(() => {
    fetchWellnessGoalsOptions()
  }, [])

  const fetchWellnessGoalsOptions = async () => {
    setIsLoading(true)

    try {
      // In production, this would be an API call to fetch wellness goals categories
      // For now, we'll use mock data
      const options = [
        { value: 'physical-activity', label: 'Physical Activity' },
        { value: 'nutrition', label: 'Nutrition' },
        { value: 'weight-management', label: 'Weight Management' },
        { value: 'sleep', label: 'Sleep Quality' },
        { value: 'hydration', label: 'Hydration' },
        { value: 'stress-management', label: 'Stress Management' },
        { value: 'mental-wellness', label: 'Mental Wellness' },
        { value: 'mindfulness', label: 'Mindfulness' },
        { value: 'social-connection', label: 'Social Connection' },
        { value: 'work-life-balance', label: 'Work-Life Balance' },
        { value: 'fitness', label: 'Fitness Level' },
        { value: 'disease-prevention', label: 'Disease Prevention' },
        { value: 'healthy-habits', label: 'Healthy Habits' },
        { value: 'life-satisfaction', label: 'Life Satisfaction' },
        { value: 'energy-levels', label: 'Energy Levels' },
        { value: 'cardiovascular-health', label: 'Cardiovascular Health' },
        { value: 'outdoor-time', label: 'Outdoor Time' },
        { value: 'screen-time-management', label: 'Screen Time Management' },
        { value: 'relaxation', label: 'Relaxation' },
        { value: 'personal-growth', label: 'Personal Growth' }
      ]

      setWellnessGoalsOptions(options)
    } catch (error) {
      console.error('Error fetching wellness goals options', error)
    }

    setIsLoading(false)
  }

  const addCustomGoalCategory = (customOption) => {
    if (!customOption || !customOption.value || !customOption.label) return

    // Check if the option already exists
    const exists = wellnessGoalsOptions.some((option) => option.value === customOption.value)
    if (exists) return

    setWellnessGoalsOptions([...wellnessGoalsOptions, customOption])
  }

  const trackGoalProgress = (goalId, progressData) => {
    // In production, this would make an API call to track goal progress
    // Implementation would depend on your backend architecture
  }

  const calculateGoalCompletion = (goal, progressData) => {
    // Simple mock implementation
    if (!goal || !progressData || !progressData.currentValue) {
      return 0
    }

    const current = progressData.currentValue
    const target = goal.targetValue

    if (target <= 0) return 0

    const percentage = (current / target) * 100
    return Math.min(100, Math.max(0, percentage)) // Ensure between 0-100
  }

  const generateGoalsReport = (userId, dateRange) => {
    // In production, this would make an API call to generate a report

    // Mock return data
    return {
      completedGoals: 3,
      inProgressGoals: 5,
      notStartedGoals: 2,
      averageCompletion: 62,
      trendingPositive: ['hydration', 'physical-activity'],
      needsAttention: ['stress-management', 'sleep']
    }
  }

  return {
    isLoading,
    wellnessGoalsOptions,
    fetchWellnessGoalsOptions,
    addCustomGoalCategory,
    trackGoalProgress,
    calculateGoalCompletion,
    generateGoalsReport
  }
}
